// eslint-disable-next-line max-len
const onePixelLightGrey =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO8dAYAAnYBoH+KtRgAAAAASUVORK5CYII=';

const generateBlurDataURL = (url: string | null | undefined): string => {
  if (!url) {
    return onePixelLightGrey;
  }
  const hasParams = url.indexOf('?') > -1;
  const paramAppender = hasParams ? '&' : '?';
  return `${url}${paramAppender}w=20&h=20`;
};

export { generateBlurDataURL, onePixelLightGrey };
